
// src/web/components/date-picker.jsx

import React from 'react'
import { translate } from 'react-i18next'
import {
  DatePicker,
} from 'react-toolbox/lib/date_picker'
import theme from './themes/date-picker.css'
import moment from 'moment'

const locale = {
  months: moment.months(),
  monthsShort: moment.monthsShort(),
  weekdays: moment.weekdays(),
  weekdaysShort: moment.weekdaysShort(),
  weekdaysLetter: moment.weekdaysShort(),
}

function _DatePicker(props) {
  const {
    t,
    label,
    value,
    maxDate,
    minDate,
    onChange,
    onDismiss,
    okLabel,
    cancelLabel,
    inputFormat,
    color,
  } = props

  return (
    <DatePicker label={!value && label}
          autoOk
          locale={locale}
          inputFormat={inputFormat || function(date) { return date && moment(date).format('LLLL') || '' }}
          value={value}
          maxDate={maxDate}
          minDate={minDate}
          onChange={onChange}
          onDismiss={onDismiss}
          okLabel={okLabel || t('label:了解')}
          cancelLabel={cancelLabel || t('label:取り消し')}
          theme={theme}
          sundayFirstDayOfWeek={true}
          style={{color: color}} />
  )
}

export default translate()(_DatePicker)



// WEBPACK FOOTER //
// ./src/web/components/date-picker.jsx